import React, { Fragment } from 'react';
import { Link } from "@quintype/components";
import { Menu } from "../menu/menu";
import { SocialFollow } from "../../basic/social-follow/social-follow";
import './sidebar.module.css';

class SidebarTemplate extends React.Component {
  constructor(props) {
    super(props);
  }

  updateCloseSidebar = (e) => {
    e.stopPropagation();
    // e.preventDefault();

    return this.props.closeSidebar();
  }

  render() {
    let {isSidebarVisible, headerConfig, closeSidebar, menuItems, publisherName, socialLinks, languageDirection, customCssClasses, toggleSidebar, closeAll} = this.props;
    return (
      <Fragment>
        <div styleName={`overlay ${customCssClasses} ${isSidebarVisible ? 'overlay--active': ''} ${headerConfig.hamburger === 'right' ? 'overlay-open-right' : 'overlay-open-left'}`} onClick={this.closeSidebar}></div>
        <div styleName={`sidebar sidebar--visible ${customCssClasses} ${headerConfig.hamburger === 'right' ? 'open-right' : 'open-left'}`}>
          <nav><Menu closeAll={closeAll} styleName="menu" menu={menuItems} sidebar languageDirection={languageDirection} toggleSidebar={toggleSidebar} /></nav>
          <SocialFollow
              hasBackground={true}
              socialLinks={socialLinks} />
        </div>
      </Fragment>
    );
  }
}

export { SidebarTemplate };
